import React from "react";

import { FieldLabel, FormCard } from "../../../../components/FormPanel";
import { ButtonTypes } from "../../../../components/Button";
import { formatOverride } from "./constants";
import { OverrideListProps } from "./types";
import {
  DeleteButton,
  EmptyList,
  OverrideList as List,
  OverrideRow,
} from "./styles";

export const OverrideList: React.FC<OverrideListProps> = ({
  overrides,
  nativeCurrency,
  isLoading,
  isDisabled,
  onDelete,
}) => {
  let body: React.ReactNode;
  if (nativeCurrency === null) {
    // No instrument chosen yet: "none saved" would assert something about a ticker the user has not named.
    body = (
      <EmptyList as="li">
        Choose an instrument to see your saved prices.
      </EmptyList>
    );
  } else if (isLoading) {
    body = <EmptyList as="li">Loading saved prices…</EmptyList>;
  } else if (overrides.length === 0) {
    body = (
      <EmptyList as="li">
        No private prices saved for this instrument.
      </EmptyList>
    );
  } else {
    body = overrides.map((override) => (
      <OverrideRow key={override.date}>
        <span>{formatOverride(override, nativeCurrency)}</span>
        <DeleteButton
          type={ButtonTypes.link}
          size="small"
          tone="danger"
          disabled={isDisabled}
          aria-label={`Delete private price for ${override.date}`}
          onClick={() => void onDelete(override.date)}
        >
          Delete
        </DeleteButton>
      </OverrideRow>
    ));
  }

  return (
    <FormCard>
      <FieldLabel as="span">Your saved prices</FieldLabel>
      <List aria-live="polite" aria-label="Saved private prices">
        {body}
      </List>
    </FormCard>
  );
};
